import React from 'react';

import { BadgeProps } from '@frontend/shadcn/components/ui/badge';
import { Tooltip, TooltipProvider, TooltipTrigger } from '@frontend/shadcn/components/ui/tooltip';

import { EnvelopeIcon } from '@/components/icons/EnvelopeIcon';
import { BadgeContent, BadgeDismissButton, BadgeTooltip, BaseBadgeWrapper, DemographicData } from './badge-parts';

interface HasEmailBadgeProps {
  data: DemographicData;
  onDismiss: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

type CombinedProps = BadgeProps & HasEmailBadgeProps;

const HasEmailBadge = React.forwardRef<HTMLDivElement, CombinedProps>(({ data, onDismiss, ...props }, ref) => {
  const formatHasEmail = (names: string[]) => {
    // Convert boolean string to readable text
    return names
      .map((name) => {
        const normalized = String(name).toLowerCase();
        return normalized === 'true' ? 'Has Email' : 'No Email';
      })
      .join(', ');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <BaseBadgeWrapper ref={ref} id={data.id} actionName="open-has-email-filters" {...props}>
              <BadgeContent
                icon={<EnvelopeIcon className="mr-2 text-[#55A2DF]" />}
                label="Contact"
                names={data.names}
                formatNames={formatHasEmail}
              />
              <BadgeDismissButton
                onDismiss={onDismiss}
                label="Contact Contact Filter"
                dismissActionName="remove-has-email-filter"
              />
            </BaseBadgeWrapper>
          </div>
        </TooltipTrigger>
        <BadgeTooltip
          tooltipTitle="Creator Contact Filter"
          label="Contact"
          names={data.names}
          formatNames={formatHasEmail}
        />
      </Tooltip>
    </TooltipProvider>
  );
});

HasEmailBadge.displayName = 'HasEmailBadge';

export default HasEmailBadge;
